import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { PendingDraft, PendingLoan, PendingRolloverin } from "../containers/";
import PendingApproval from "../containers/Transaction/PendingApproval";
import {
  Approval,
  LoanRequestsPendingApproval,
  ManageLoan,
  ManageRolloverin,
  RollOverRequestsPendingApproval,
  WithdrawalRequestsPendingApproval,
  TransactionHistory,
  RolloverTransactionHistoryDetails,
  DistributionTransactionHistoryDetails,
  TransferHistoryDetails,
  LoanTransactionHistoryDetails,
} from "../layouts";
import ManageApproval from "../layouts/Transaction/ManageApproval";
import { ApplicationRoute } from "../utils";

import { ROUTES, MANAGE_TRANSACTION_ROUTES } from "../utils";

const menu = "transaction";
export const ManageTransactionRoutes = () => {
  return (
    <Switch>
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_TRANSACTION_ROUTES.APPROVAL}
        component={Approval}
      />

      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_TRANSACTION_ROUTES.DRAFT}
        component={PendingDraft}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_TRANSACTION_ROUTES.HISTORY}
        component={TransactionHistory}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={`${MANAGE_TRANSACTION_ROUTES.ROLLOVER_HISTORY_DETAILS}/:censusId?/:loanId?`} ///
        component={RolloverTransactionHistoryDetails}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={`${MANAGE_TRANSACTION_ROUTES.DISTRIBUTION_HISTORY_DETAILS}/:censusId?/:loanId?`} ///
        component={DistributionTransactionHistoryDetails}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={`${MANAGE_TRANSACTION_ROUTES.TRANSFER_HISTORY_DETAILS}/:censusId?/:loanId?`} ///
        component={TransferHistoryDetails}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={`${MANAGE_TRANSACTION_ROUTES.LOAN_HISTORY_DETAILS}/:censusId?/:loanId?`} ///
        component={LoanTransactionHistoryDetails}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL}
        component={ManageApproval}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_TRANSACTION_ROUTES.PENDINGLOAN}
        component={ManageLoan}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_TRANSACTION_ROUTES.PENDINGROLLOVERIN}
        component={ManageRolloverin}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={`${MANAGE_TRANSACTION_ROUTES.PENDINGROLLOVERINAPPROVAL}/:censusId?/:summaryId?`} ///
        component={RollOverRequestsPendingApproval}
      />

      <ApplicationRoute
        exact
        menu={menu}
        path={`${MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWALAPPROVAL}/:flow(add|edit|save)/:censusId/:withdrawalRequestId?/:fromPage`} ///
        component={WithdrawalRequestsPendingApproval}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={`${MANAGE_TRANSACTION_ROUTES.PENDINGLOANAPPROVAL}/:flow(add|edit|save)/:censusId/:loanRequestId?/:fromPage`} ///
        component={LoanRequestsPendingApproval}
      />
      <Redirect
        exact
        from={ROUTES.TRANSACTION}
        to={MANAGE_TRANSACTION_ROUTES.APPROVAL}
      />
    </Switch>
  );
};
